/** Mirrors backend SCAN_INVALID_REASONS — keep in sync when adding rules */
export const SCAN_INVALID_REASONS = {
    NOT_IN_STORE: "NOT_IN_STORE",
};

export const INVALID_REASON_LABELS = {
    NOT_IN_STORE: "Not in store price book",
    INVALID_LENGTH: "Invalid barcode length",
    INVALID_CHARACTERS: "Invalid barcode characters",
};

export const reasonToErrorType = (invalidReason) => {
    if (invalidReason === SCAN_INVALID_REASONS.NOT_IN_STORE) return "NOT_IN_STORE";
    return null;
};

export const formatInvalidLabel = (item) => {
    if (item.invalidReason && INVALID_REASON_LABELS[item.invalidReason]) {
        return INVALID_REASON_LABELS[item.invalidReason];
    }
    if (item.errorType && INVALID_REASON_LABELS[item.errorType]) {
        return INVALID_REASON_LABELS[item.errorType];
    }
    return "Not in store";
};
